module.exports = __webpack_public_path__ + "img/building.e1f08df4.png";